module.exports = __webpack_public_path__ + "static/media/image-18.784c42ba.jpg";